<template>
  <div class="order-detail-contain">
    <el-tabs v-model="activeName" @tab-change="handleClick">
      <el-tab-pane label="付款单基础" name="first">
        <createList @getPaymentInfo="getPaymentInfo"></createList>
      </el-tab-pane>
      <el-tab-pane label="付款单详情" name="second" :disabled="secondAble">
        <createDetails
          ref="detailInfo"
          :createListInfo="createListInfo"
        ></createDetails>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { computed, ref } from "vue";
import createList from "./createList.vue";
import createDetails from "./createDetails.vue";
import { useRoute } from "vue-router";
export default {
  name: "createFinancePayment",
  components: {
    createDetails,
    createList,
  },
  setup() {
    const pay_id = ref("");
    const pay_no = ref("");
    const detailInfo = ref(null);
    const route = ref(useRoute());
    const secondAble = computed(() => {
      let flag = route.value.query.arrData[0] == "udt" || pay_id.value;
      return !flag;
    });
    const createListInfo = ref(null);
    const activeName = ref("first");
    const handleClick = (TabPanelName) => {
      if (TabPanelName == "second") {
        detailInfo.value.getPaymentDetails();
      }
    };
    const getPaymentInfo = (val) => {
      const obj = detailInfo.value;
      obj.pay_id = val.pay_id;
      obj.pay_no = val.pay_no;
      activeName.value = "second";
      obj.getPaymentDetails();
    };
    return {
      activeName,
      handleClick,
      getPaymentInfo,
      createListInfo,
      secondAble,
      detailInfo,
    };
  },
};
</script>
<style scoped>
.order-detail-contain {
  padding: 20px 0;
}
</style>
